import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL, authFetch } from "../utils/auth";
import PartnerNotifications from "../partners/notifications/PartnerNotifications";
import ClientNotificationsPage from "../clients/notifications/ClientNotificationsPage";

function notificationMode(partner) {
  const isInternal = localStorage.getItem("is_internal") === "true";
  const isSuperuser = localStorage.getItem("is_superuser") === "true";
  const role = localStorage.getItem("portal_role") || "client";
  if (isSuperuser || isInternal || ["hr", "project_manager", "developer", "designer", "marketing", "staff", "superuser"].includes(role)) {
    return "portal";
  }
  return partner ? "partner" : "client";
}

function notificationEndpoint(mode, suffix) {
  if (mode === "partner") return `${API_URL}/partner/notifications/${suffix}`;
  if (mode === "client") return `${API_URL}/client/notifications/${suffix}`;
  return `${API_URL}/notifications/${suffix}`;
}

export default function Notifications({ partner }) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const mode = notificationMode(partner);

  useEffect(() => {
    async function load() {
      try {
        const res = await authFetch(notificationEndpoint(mode, "all/"));
        const data = await res.json();
        setNotifications(Array.isArray(data) ? data : data.results || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, [mode]);

  const markAsRead = async (id) => {
    const response = await authFetch(notificationEndpoint(mode, `${id}/read/`), { method: "POST" });
    if (!response.ok) return;

    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, read: true, is_read: true } : n))
    );
  };

  const markAllAsRead = async () => {
    const response = await authFetch(notificationEndpoint(mode, "read-all/"), { method: "POST" });
    if (!response.ok) return;

    setNotifications((prev) => prev.map((n) => ({ ...n, read: true, is_read: true })));
  };

  const openNotification = async (notification) => {
    if (!notification?.path) return;
    if (!notification.read) await markAsRead(notification.id);
    navigate(notification.path);
  };

  if (loading) return <p>Loading...</p>;

  return mode === "partner" ? (
    <PartnerNotifications
      notifications={notifications}
      markAsRead={markAsRead}
      markAllAsRead={markAllAsRead}
      openNotification={openNotification}
    />
  ) : (
    <ClientNotificationsPage
      notifications={notifications}
      markAsRead={markAsRead}
      markAllAsRead={markAllAsRead}
      openNotification={openNotification}
    />
  );
}